var Config = {
    LIMIT: "10",
    PERSIST_SECRET_KEY: "098d7e400fed596e5068010e85aca0e7",
    ENVIRONMENT: "STAGING",
    ENVIRONMENTS: {
        LOCAL: {
            API_URL: "https://demo-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://demo-admin.casita.kodefuse.com",
        },
        DEVELOPMENT: {
            API_URL: "https://demo-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://demo-admin.casita.kodefuse.com",
        },
        STAGING: {
            API_URL: "https://demo-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://demo-admin.casita.kodefuse.com",
        },
        PRODUCTION: {
            API_URL: "https://demo-api.casita.kodefuse.com/v1",
            DOMAIN_URL: "https://demo-admin.casita.kodefuse.com",
        },
    },
}

Config.env = () => {
    return Config.ENVIRONMENTS[Config.ENVIRONMENT]
}

export default Config